import { OperationalSchedule } from '@/src/models/outlet-detail';

export const formatSchedule = (item: OperationalSchedule) => {
  if (item.OutletHolidayYN === 'Y' || !item.OpenTime || !item.CloseTime) {
    return 'Tutup';
  }

  return `${item.OpenTime} – ${item.CloseTime}`;
};

export const getSortedSchedule = (schedules: OperationalSchedule[] = []) => {
  return [...schedules].sort((a, b) => Number(a.DayWeek) - Number(b.DayWeek));
};
